import { useContext } from "react";
import { AuthenticationContext } from "core/iam/AuthenticationProvider";

export function useIsAuthenticated(): boolean {
  return useContext(AuthenticationContext).authenticated;
}

export function useAuthenticatedUser() {
  const user = useContext(AuthenticationContext).user;

  if (!user) {
    throw new Error("This hooks must be used within an authenticated context.");
  }

  return user;
}

export function useLogin() {
  const ctx = useContext(AuthenticationContext);

  return ctx.login;
}

export function useLogout() {
  const authentication = useContext(AuthenticationContext);

  return async () => {
    if (authentication.authenticated) {
      await authentication.logout();
    }
  };
}
